import styled from 'styled-components';

export const RowLine = styled.section`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  p {
    margin-right: 1rem;
  }
  span {
    display: block;
  }
`;
export const SpanBlock = styled.section`
  display: block;
`;
